import { Chatbot } from './components/Chatbot';

function App() {
  return (
    <div className="w-full h-full flex flex-col justify-end items-end relative top-16">
      <Chatbot />
    </div>
  );
}

export default App;